import _classCallCheck from "/home/livesetup/Desktop/Blockchain/Dapp/kigali-dex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/livesetup/Desktop/Blockchain/Dapp/kigali-dex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/livesetup/Desktop/Blockchain/Dapp/kigali-dex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/livesetup/Desktop/Blockchain/Dapp/kigali-dex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/livesetup/Desktop/Blockchain/Dapp/kigali-dex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { PureComponent } from 'react';
import { OrderbookDeepChart } from './deepChartCanvas';
import { themeDark, themeLight } from '../variables/variables';
import { setBids, setAsks } from './memoryOrderbook';

var DeepChart = /*#__PURE__*/function (_PureComponent) {
  _inherits(DeepChart, _PureComponent);

  function DeepChart() {
    _classCallCheck(this, DeepChart);

    return _possibleConstructorReturn(this, _getPrototypeOf(DeepChart).apply(this, arguments));
  }

  _createClass(DeepChart, [{
    key: "getVariables",
    value: function getVariables() {
      var theme = this.props.theme;
      return theme === 'light' ? themeLight : themeDark;
    }
  }, {
    key: "getCommonOptions",
    value: function getCommonOptions() {
      var _this = this;

      var _this$props = this.props,
          baseToken = _this$props.baseToken,
          quoteToken = _this$props.quoteToken,
          priceDecimals = _this$props.priceDecimals,
          amountDecimals = _this$props.amountDecimals,
          clickCallback = _this$props.clickCallback,
          styles = _this$props.styles;
      var variables = this.getVariables();
      return {
        height: -1,
        showFPS: false,
        priceDecimals: priceDecimals,
        amountDecimals: amountDecimals,
        baseTokenSymbol: baseToken,
        quoteTokenSymbol: quoteToken,
        titleColor: styles && styles.titleColor || variables.mainColor,
        axisLabelColor: styles && styles.axisLabelColor || variables.secondColor,
        axisColor: styles && styles.axisColor || variables.borderGray,
        rowBackgroundColor: styles && styles.rowBackgroundColor || variables.backgroundContainer,
        containerBackgroundColor: styles && styles.containerBackgroundColor || variables.background,
        red: styles && styles.askColor || variables.red,
        redArea: styles && styles.askColorArea || variables.redArea,
        green: styles && styles.bidColor || variables.green,
        greenArea: styles && styles.bidColorArea || variables.greenArea,
        onClick: function onClick(result) {
          // console.log(result);
          if (clickCallback) {
            clickCallback(result);
          }
        },
        formatXAxisLabel: function formatXAxisLabel(price) {
          return "".concat(price.toString(), " ").concat(_this.props.quoteToken);
        },
        formatYAxisLabel: function formatYAxisLabel(amount) {
          if (amount.gt(1000)) {
            return "".concat(amount.div(1000).toFixed(2), "k");
          } else if (amount.gt(1000000)) {
            return "".concat(amount.div(1000000).toFixed(2), "m");
          } else {
            return amount.round(0).toString();
          }
        }
      };
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      setBids(nextProps.bids);
      setAsks(nextProps.asks);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          bids = _this$props2.bids,
          asks = _this$props2.asks;
      setBids(bids);
      setAsks(asks);
      var commonOptions = this.getCommonOptions();
      this.chart = new OrderbookDeepChart('deep-chart', commonOptions);
      this.chart.start();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var commonOptions = this.getCommonOptions();

      if (this.chart) {
        this.chart.updateOptions(commonOptions);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.chart) {
        this.chart.stop();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("canvas", {
        id: "deep-chart",
        style: {
          width: '100%',
          height: '100%'
        }
      });
    }
  }]);

  return DeepChart;
}(PureComponent);

export default DeepChart;